import './styles/reviews.css'
import starSvg from '../assets/icons/star.png'
import Slider from './Slider'

const cards = [
    {
        name:'Monica Smith',
        status:'Student',
        review:`Overall experience is awesome!!
         I'm a visual thinker, and I couldn't function without a tool like this.`
    },
    {
        name:'Vincent Smith',
        status:'Student',
        review:`Overall experience is awesome!!
         I'm a visual thinker, and I couldn't function without a tool like this.`
    },
    {
        name:'Stella Smith',
        status:'Job seeker',
        review:`Overall experience is awesome!!
         I'm a visual thinker, and I couldn't function without a tool like this.`
    },
]

export default function Reviews() {
  return (
    <div id='blog' className='reviews'>
      <div className='container'>
            <div className='reviews__head'>
                <div className="reviews__title">
                    Don't take it from us
                </div>
                <div className="reviews__subtitle">
                    Customer satisfaction is a primary goal for our company
                </div>
            </div>
            <div className='reviews__cards'>
                {cards.map((card,index) => {
                    return (
                        <div className='reviews__card' key={index}>
                            <div className="reviews__card-img">
                            </div>
                            <div className="reviews__card-name">
                                {card.name}
                            </div>
                            <div className="reviews__card-status">
                                {card.status}
                            </div>
                            <div className="reviews__card-rating">
                                <img src={starSvg} alt={'start'}/>
                                <img src={starSvg} alt={'start'}/>
                                <img src={starSvg} alt={'start'}/>
                                <img src={starSvg} alt={'start'}/>
                                <img src={starSvg} alt={'start'}/>
                            </div>
                            <div className="reviews__card-text">
                                {card.review}
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className='reviews-mobile__cards'>
                <Slider items={cards} checked={true} type={'reviews'}/>
            </div>
      </div>
    </div>
  )
}
